export const CONST_INSTITUTIONAL_STATUS = Object.freeze({
   HISTORICO: {
		id					: 0,
		description	: "Histórico"
	},
	ON_EDITING: {
		id					: 1,
		description	: "Em Edição"
	},

  DRAFT: {
		id					: 2,
		description	: "Rascunho"
	},

  ON_APPROVAL: {
		id					: 3,
		description	: "Em Aprovação"
	},

	ADJUSTMENT_REQUESTED: {
		id					: 4,
		description	: "Solicitado Ajuste"
	},

  APPROVED: {
		id					: 5,
		description	: "Aprovado"
	},	

  PUBLISHED: {
		id					: 6,
		description	: "Cadastro Publicado"
	},

  CANCELED: {
		id					: 7,
		description	: "Cancelado"
	},

  PENDING_PUBLICATION: {
		id					: 9,
		description	: "Pendente Publicação"
	},

  ACTIVE_INSTITUTIONAL: {
		id					: 10,
		description	: "Tela Institucional Ativa"
	},

  INSTITUTIONAL_COMPLETED: {
		id					: 11,
		description	: "Tela Institucional Concluída"
	},

	ON_REISSUE: {
		id					: 12,
		description	: "Em Reedição"
	},

	ON_RE_APPROVAL: {
		id					: 13,
		description	: "Em Reaprovação"
	},

	ADJUSTMENT_REQUESTED_AGAIN: {
		id					: 14,
		description	: "Solicitado Reajuste"
	},

	REAPPROVED: {
		id					: 15,
		description	: "Reaprovado"
	}
});

export const CONST_STATUS = Object.freeze([
	{
		id					: 0,
		description	: "Histórico"
	},
  {
		id					: 1,
		description	: "Em Edição"
	},

  {
		id					: 2,
		description	: "Rascunho"
	},

  {
		id					: 3,
		description	: "Em Aprovação"
	},

	{
		id					: 4,
		description	: "Solicitado Ajuste"
	},

 {
		id					: 5,
		description	: "Aprovada"
	},	

 {
		id					: 6,
		description	: "Campanha Publicada!"
	},

  {
		id					: 7,
		description	: "Cancelada"
	},

	{
		id					: 9,
		description	: "Pendente Publicação"
	},

	{
		id					: 10,
		description	: "Campanha Ativa"
	},

	{
		id					: 11,
		description	: "Campanha Concluída"
	},

	{
		id					: 12,
		description	: "Em Reedição"
	},

	{
		id					: 13,
		description	: "Em Reaprovação"
	},

	{
		id					: 14,
		description	: "Solicitado Reajuste"
	},

	{
		id					: 15,
		description	: "Reaprovada"
	}
]);

export const CONST_INSTITUTIONAL_ATM_SCREEN_FORMAT_SCREEN_OPTIONS = Object.freeze([
	{
		screenId					: "1",
		screenDescription	: "A1 - Abertura"
	},

	{
		screenId					: "2",
		screenDescription	: "A2 - PropagIF"
	},

	{
		screenId					: "3",
		screenDescription	: "A3 - Retire o seu Dinheiro"
	}
]);

export const USER_ROLES = Object.freeze({
	ADMIN: {
		id		: 0,
		value	: "administrator"
	},

	READ_ONLY: {
		id		: 1,
		value	: "read_only"
	},

	CONTENT_MANAGER: {
		id		: 2,
		value	: "content_manager"
	},

	ASSESSMENT_TEAM: {
		id		: 3,
		value	: "AssessmentTeam"
	},
	PRODUCTION_TI: {
		id		: 4,
		value	: "productionTI"
	}
});

export const ATM_ALLOWED_IMAGE_DIMENSIONS = Object.freeze({
	width		: 640,
	height	: 480
});

export const INSTITUTIONAL_USER_ROLES = Object.freeze({
  ADMIN: '_apl_midia_telas_admin',

  B24H_MANAGER: '_apl_midia_telasb24h_gestorConteudo',
  B24H_REVIEW: '_apl_midia_telasb24h_avaliador',
  B24H_VIEW: '_apl_midia_telasb24h_consulta',

  ATMM_MANAGER: '_apl_midia_telasatmm_gestorConteudo',
  ATMM_REVIEW: '_apl_midia_telasatmm_avaliador',
  ATMM_VIEW: '_apl_midia_telasatmm_consulta'
});

export const DEFAULT_IFS_EXPORT_FILENAME = 'Instituições.csv';
export const DEFAULT_PCS_EXPORT_FILENAME = 'PCs.csv'; 
export const DEFAULT_DISTRIBUTION_EXPORT_FILENAME = 'Distribuicoes';
export const DEFAULT_PC_GROUP_EXPORT_FILENAME = 'PCs{0}.csv';